import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledProgressBar = styled.span`
height: 6px;
margin-right: 8px;
background: #CBCBCB;
border-radius: 3px;
width: ${props => (props.perc ? `${props.perc}%` : '0%')};
display: inline-block;

`

const StyledProgressBarText = styled.span`
font-family: 'Roboto';
font-style: italic;
font-weight: 400;
font-size: 12px;
line-height: 14px;
letter-spacing: 0.192857px;
color: #7C7C7C;
position: relative;
top: 1px;
`

export const ProgressBarSmall = (props) => {
  return (<div>
    <StyledProgressBar {...props} />
    <StyledProgressBarText>{props.perc}%</StyledProgressBarText>
  </div>

  )
}
